import { useState } from "react";


import { DataContext } from "../../../Context/HelperOne";
import NavBar from "../nav_bar/Navbar";
import LoanList from "./LoanList";

const Loan = () => {
    const [searchUi, setSearchUi] = useState(false)
    const [searchData, setSearchData] = useState(null)

    return (
        <DataContext.Provider value={{ searchUi, setSearchUi, searchData, setSearchData }}>
            <NavBar
                childrenPage={<LoanList />}
                menuId={11}
            />
        </DataContext.Provider>
    )
}

export default Loan
